import styled from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 8px;
  overflow: hidden;
  padding-top: 26px;
`;
Wrapper.displayName = 'Wrapper';

export const MeasureRow = styled.div`
  position: absolute;
  visibility: hidden;
  height: 0;
  width: max-content;
  overflow: hidden;
  display: flex;
  gap: 8px;
  pointer-events: none;
`;
MeasureRow.displayName = 'MeasureRow';

export const Category = styled.div`
  background-color: ${({ theme }) => theme.backgrounds.attributeTag};
  border-radius: 0;
  border: solid 1px ${({ theme }) => theme.borders.attributeTag};
  color: ${({ theme }) => theme.text.attributeTag};
  font-size: 12px;
  font-weight: 500;
  padding: 0 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  flex: none;
  max-width: 220px;
`;
Category.displayName = 'Category';

export const CategoryLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;
CategoryLabel.displayName = 'CategoryLabel';

export const MoreCategory = styled(Category)`
  background-color: transparent;
  border-style: dashed;
  border-color: ${({ theme }) => theme.text.workspaceItem};
  color: ${({ theme }) => theme.text.workspaceItem};
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.borders.workspaceSelectedItem};
    outline-offset: 2px;
  }
`;
MoreCategory.displayName = 'MoreCategory';
